import axios from 'axios';
import { store } from '~redux_related/store';

export const newsAPI = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};
export const newsProdPDFAPI = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: 'https://tracktrack.su/api',
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/pdf',
        },
    };
    return axios.create(params);
};
export const newsProdDOCAPI = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: 'https://tracktrack.su/api',
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
    };
    return axios.create(params);
};
export const newsProdFileAPI = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: 'https://tracktrack.su/api',
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
        },
    };
    return axios.create(params);
};

export const newsAPIMultipart = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'content-type': 'multipart/form-data',
        },
    };
    return axios.create(params);
};

export const newsAPILite = function () {
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};

export const newsDigestsAPI = function () {
    const params = {
        baseURL: 'https://news-digest.tracktrack.ru/api/',
        headers: {
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};

export const newsDigestsAPIToken = function () {
    const params = {
        baseURL: 'https://test.news.tracktrack.ru/api',
        headers: {
            // 'frontendkey': process.env.FRONTENDKEY,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};



// WEBPACK FOOTER //
// ./src/api/news.js